module.exports = __webpack_public_path__ + "static/media/sec1.dc667a81.svg";